export const participationRateMaintenanceRequiredFieldList: string[] = [
    'participationRate',
];

export const ParticipationRateMaintenanceConstant = {
    CATEGORY: "Charge",
    TITLE: "Participation Rate",
    PRIORITY: "Priority",
    CONSORTIUM_CODE: "Consortium Code",
    VESSEL_CODE: "Vessel Code",
    VOYAGE_CODE: "Voyage Code",
    SOA: "SOA",
    ETD: "ETD",
    ETB: "ETB",
    CONTAINER_STATUS: "Container Status",
    ACTIVE_IND: 'Active Ind.',
    ETD_DATE_RANGE: 'ETD Range',
    CO_VSL_VOY: 'Co/Vsl/Voy',
}
